import { UsersApi } from '../../../api-client';
import { UseMutationOptions } from 'react-query/types/react/types';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '../../../common/types/errorRespose';
import { useMutation, UseMutationResult } from 'react-query';

export type removeUserVariables = {
  userId: string,
  groupId: string,
};

type UseRemoveAddUserFromGroup = (
  usersApi: UsersApi,
  options?: Omit<
    UseMutationOptions<AxiosResponse<void>, ErrorResponse, removeUserVariables>,
    'mutationFn'
    >,
) => UseMutationResult<AxiosResponse<void>, ErrorResponse, removeUserVariables>;

export const useRemoveUserFromGroup: UseRemoveAddUserFromGroup = (
  usersApi,
  options,
) => {
  const tenantId = localStorage.getItem('tenantId') as string;
  return useMutation(
    ({ userId, groupId }) => usersApi.deleteUserGroupLink(tenantId, userId, groupId),
    options,
  );
};
